module.exports = __webpack_public_path__ + "static/media/grey_expansion.9d25204f.svg";